const globalPseudoClassesMapping: Record<string, string> = {
  active: 'kaltura-ds-active',
  checked: 'kaltura-ds-checked',
  disabled: 'kaltura-ds-disabled',
  error: 'kaltura-ds-error',
  focused: 'kaltura-ds-focused',
  focusVisible: 'kaltura-ds-focusVisible',
  required: 'kaltura-ds-required',
  expanded: 'kaltura-ds-expanded',
  selected: 'kaltura-ds-selected',
};

export function generateUtilityClass(
  componentName: string,
  slot: string
): string {
  const globalPseudoClass = globalPseudoClassesMapping[slot];
  return globalPseudoClass || `${componentName}-${slot}`;
}
